module.exports = __webpack_public_path__ + "img/D202208_3.5ab13eaa.jpg";